/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 약관 조회 응답
 * @export
 * @interface TermsResponse
 */
export interface TermsResponse {
    /**
     * 전자금융거래 약관 내용
     * @type {string}
     * @memberof TermsResponse
     */
    'electronicFinancialTransactions': string;
    /**
     * 개인정보 수집·이용 약관 내용
     * @type {string}
     * @memberof TermsResponse
     */
    'collectPersonalInfo': string;
    /**
     * 개인정보 제3자 제공 약관 내용
     * @type {string}
     * @memberof TermsResponse
     */
    'sharingPersonalInformation': string;
    /**
     * 통신과금 서비스 약관 내용
     * @type {string}
     * @memberof TermsResponse
     */
    'telecommunicationCharging': string;
}

